import { atom } from 'recoil';

export const dataUserForm = atom({
  key: 'dataUserForm',
  default: undefined,
});
